;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .constant('BASIC_AUTH_I18_STR', 'title_integrationsSettings_basicAuth')
    .constant('JENKINS_AUTH_TYPES', [
      { value: 'BASIC', name: 'title_integrationsSettings_basicAuth' },
      { value: 'OAUTH2', name: 'OAuth2' }
    ])
    .constant('JENKINS_BASIC_AUTH', 'BASIC')
    .constant('JENKINS_NONE_VAL', 'NONE')
})()
